"use strict";
/* ====== START OF CUSTOM SCRIPTS ====== */
// PRODUCT SELECTOR
const clickFirstVisibleLabel = () => {
    const firstVisibleElement = Array.from(document.querySelectorAll('[data-option-position="2"] label')).find((element) => {
        let width = 0;
        if (element) {
            width = element.getBoundingClientRect().width;
        }
        return width > 0;
    });
    // check if selected is visible
    const selectedDays = document.querySelector('[data-option-position="2"] input:checked ~ label');
    const isSelectedVisible = selectedDays
        ? selectedDays.getBoundingClientRect().width > 0
        : false;
    if (!isSelectedVisible && (firstVisibleElement === null || firstVisibleElement === void 0 ? void 0 : firstVisibleElement.click)) {
        firstVisibleElement.click();
    }
};
const days = ['1', '2', '3', '4', '5'];
let observer;
const addCallbacksToDaysSelector = () => {
    const interval = setInterval(() => {
        if (!scriptLoaded.daysSelector) {
            const labels = document.querySelectorAll('[data-option-position="1"] label');
            if (labels.length >= 2 &&
                labels.length <= 5 &&
                // days.includes(labels[0]?.textContent?.trim() || "") &&
                // days.includes(labels[1]?.textContent?.trim() || "") &&
                document.querySelectorAll('[data-option-position="2"] label').length >=
                    1) {
                document
                    .querySelectorAll('[data-option-position="1"] label')
                    .forEach((button) => {
                    button.addEventListener('click', () => {
                        setTimeout(() => {
                            clickFirstVisibleLabel();
                        }, 800);
                    });
                });
                scriptLoaded.daysSelector = true;
                clearInterval(interval);
                // Also need to make sure it reattaches when DOM changes.
                const target = document.querySelector('.product__form__outer');
                if (!observer && target) {
                    observer = new MutationObserver((mutations) => {
                        addCallbacksToDaysSelector();
                        clickFirstVisibleLabel();
                    });
                    observer.observe(target, {
                        childList: true,
                        subtree: true,
                        characterData: true, // detects text changes
                    });
                }
            }
        }
    }, 100);
};
// MINIMUM QUANTITY
const MINIMUM_PRICE_PER_COLLECTION = 19 * 100;
const IGNORE_VENDORS = ['Nourish Program'];
const showModal = () => {
    const modal = document.querySelector('#min-order-value-error');
    modal.setAttribute('open', '1');
};
const hideModal = () => {
    const modal = document.querySelector('#min-order-value-error');
    modal.removeAttribute('open');
};
const setCollectionNamesInModal = (collections) => {
    document.querySelector('#min-order-value-error-collections').textContent =
        collections;
};
const getMinimumPriceNotMetForCollections = () => {
    const collections = {};
    document.querySelectorAll('.cart__item').forEach((cartItem) => {
        const vendor = cartItem.getAttribute('data-vendor');
        const collectionHandle = cartItem.getAttribute('data-collection-handle');
        const collectionName = cartItem.getAttribute('data-collection-name');
        const price = cartItem.getAttribute('data-price');
        if (price &&
            collectionHandle &&
            vendor &&
            !IGNORE_VENDORS.includes(vendor)) {
            if (!collections[collectionHandle]) {
                collections[collectionHandle] = {
                    name: String(collectionName),
                    price: Number(price),
                };
            }
            else {
                collections[collectionHandle].price += Number(price);
            }
        }
    });
    // console.log({ collections });
    const minimumPriceNotMetForCollections = Object.keys(collections)
        .map((collectionHandle) => collections[collectionHandle])
        .filter((collection) => collection.price < MINIMUM_PRICE_PER_COLLECTION)
        .map((collection) => `"${collection.name}"`)
        .join(', ');
    return minimumPriceNotMetForCollections;
};
const addMinimumQuantityFormCallback = () => {
    const interval = setInterval(() => {
        if (!scriptLoaded.minimumQuantity) {
            const form = document.querySelector('form.cart__form');
            if (form) {
                clearInterval(interval);
                scriptLoaded.minimumQuantity = true;
                form.addEventListener('submit', (event) => {
                    const minimumPriceNotMetForCollections = getMinimumPriceNotMetForCollections();
                    if (minimumPriceNotMetForCollections.length > 0) {
                        event.preventDefault();
                        setCollectionNamesInModal(minimumPriceNotMetForCollections);
                        showModal();
                    }
                });
                document
                    .querySelectorAll('.close-min-order-modal')
                    .forEach((element) => {
                    element.addEventListener('click', hideModal);
                });
            }
        }
    }, 100);
};
// SHARED
const scriptLoaded = {
    daysSelector: false,
    minimumQuantity: false,
};
function domReady(callback) {
    // If we're early to the party
    document.addEventListener('DOMContentLoaded', callback);
    // If late; I mean on time.
    if (document.readyState === 'interactive' ||
        document.readyState === 'complete') {
        callback();
    }
}
domReady(addCallbacksToDaysSelector);
domReady(addMinimumQuantityFormCallback);
/* ====== END OF CUSTOM SCRIPTS ====== */
